import { Validateable } from "@models/interfaces/validateable";
import { stripFunnyInput } from "@helpers/utils";

export class InternalTransaction extends Validateable {
	private amount_fiat: string = null;
	private amount: string = "";
	private from: string = "";
	private to: string = "";
	private sendFlowAccess: boolean = false;

	public getAmountTradable(): string {
		return this.amount;
	}

	public setAmountTradable(n: string): void {
		this.amount = stripFunnyInput(n);
	}

	public getAmountFiat(): string {
		return this.amount_fiat;
	}

	public setSendFlowAccess(b: boolean): void {
		this.sendFlowAccess = b;
	}

	public getSendFlowAccess(): boolean {
		return this.sendFlowAccess;
	}

	public setFrom(s: string): void {
		this.from = s;
	}

	public setAmountFiat(n: string): void {
		this.amount_fiat = stripFunnyInput(n);
	}

	public getWalletId(): string {
		return this.from;
	}
}
